import axios from 'axios';

const isLocalHost = ['localhost', '127.0.0.1'].includes(
    window.location.hostname
);
const apiBaseURL =
    process.env.REACT_APP_API_BASE_URL ||
    (isLocalHost ? 'http://localhost:8000' : '');

export default axios.create({
    baseURL: apiBaseURL,
});
